import { numberToPrettyString } from '@cian/utils';

export const formatPrice = (value: number) => {
  return numberToPrettyString(value) + ' ₽';
};
